var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr commonborder flex_row"},[_c('div',{staticClass:"echarts",attrs:{"id":"pr_line1"}})])}]

export { render, staticRenderFns }